"use strict";

export default class SceneFac {
  static get UID() {
    return "sceneFac";
  }

  constructor($http, BASE_URLS, siteConst, $filter) {
    "ngInject";
    Object.assign(this, { $http, BASE_URLS, siteConst, $filter });
  }

  getScenes(count, skip) {
    var url = `${this.BASE_URLS.API}/api/site/${
      this.siteConst.id
    }/scenes/${count}`;

    url += skip !== undefined && !isNaN(skip) ? "/" + skip : "";

    return this.fetchData(url);
  }

  getScene(id) {
    var url = `${this.BASE_URLS.API}/api/scene/${id}`;
    return this.fetchData(url);
  }

  getModel(modelId) {
    const url = `${this.BASE_URLS.API}/api/scene/model/${modelId}`;
    return this.$http.get(url).then(response => {
      const data = response.data.data;
      data.scenes.map(x => this.additionalSceneProps(x));

      return data;
    });
  }

  getTrailer(sceneId) {
    var url = `${this.BASE_URLS.API}/api/scene/${sceneId}/trailer`;
    return this.fetchData(url);
  }

  getRelatedScenes(sceneId, count = 5) {
    var url = `${this.BASE_URLS.API}/api/scene/${sceneId}/related/${count}`;
    return this.$http.get(url).then(response => {
      return Array.isArray(response.data.data)
        ? response.data.data.map(x => this.additionalSceneProps(x))
        : this.additionalSceneProps(response.data.data);
    });
  }

  fetchData(url) {
    return this.$http.get(url).then(response => {
      return Array.isArray(response.data.data)
        ? response.data.data.map(x => this.additionalSceneProps(x))
        : this.additionalSceneProps(response.data.data);
    });
  }

  additionalSceneProps(scene) {
    const videoTime =
      scene.full_length || scene.parts_sum_length || scene.trailer_length;
    const videoLengths = this.$filter("videoTime")(videoTime);
    scene.maxDate = scene.updates
      ? scene.updates[0].live_date
      : scene.max_ud_date;
    scene.minDate = scene.updates
      ? scene.updates[scene.updates.length - 1].live_date
      : scene.min_ud_date;
    scene.video_length = videoLengths || "00:00:00"

    return scene;
  }

  static factory($http, BASE_URLS, siteConst, $filter) {
    return new SceneFac($http, BASE_URLS, siteConst, $filter);
  }
}

SceneFac.factory.$inject = SceneFac.$inject;



// WEBPACK FOOTER //
// ./src/app/factories/sceneFac.js